import { useBasicInfo } from '../_shared/contexts/BasicInfoContext';
import { useUserData } from '@/hooks/useUserData';
import { WaitingRoomBanner, CreatorBanner } from './notificationBannerUseCases';
import { useWaitingRoomStatus } from '@/hooks/useWaitingRoomStatus';
import { useState } from 'react';
import { NotificationBannerFrame } from './NotificationBannerFrame';

type NotificationBannerProps = {
  priorityBanner?: React.ReactNode;
};

export const NotificationBanner: React.FC<NotificationBannerProps> = ({ priorityBanner }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const { organizationId } = useBasicInfo();
  const { canManageEvent, isLoading: isUserDataLoading } = useUserData();
  const { waitingRoomStatus, isLoading: isWaitingRoomStatusLoading } = useWaitingRoomStatus({
    organizationId: organizationId ?? '',
  });
  const isLoading = isUserDataLoading || isWaitingRoomStatusLoading;

  const closeBanner = () => {
    setIsBannerVisible(false);
  };

  if (priorityBanner) {
    return <NotificationBannerFrame>{priorityBanner}</NotificationBannerFrame>;
  }

  const eligibleBanners = [
    canManageEvent && <CreatorBanner />,
    waitingRoomStatus?.activated && <WaitingRoomBanner onCloseClick={closeBanner} />,
  ].filter(Boolean);

  if (isLoading || eligibleBanners.length === 0 || !isBannerVisible) return null;

  return <NotificationBannerFrame>{eligibleBanners.length > 0 ? eligibleBanners[0] : null}</NotificationBannerFrame>;
};
